module.exports = __webpack_public_path__ + "img/type_curtain_coil.ac4017f2.jpg";